import { Component, PropSync, Vue } from "vue-property-decorator";

@Component<LightBoxDelete>({
  components: {}
})
export default class LightBoxDelete extends Vue {
  @PropSync("show", { type: Boolean })
  syncedShow!: boolean;

  private confirmDelete() {
    this.$emit("confirmDelete");
  }

  private cancel() {
    this.$emit("cancel");
  }
}
